require('./dialog.scss');

const React = require('react');
import { preventScrollIntoScroll } from '../../../helper/common-helper.js';

module.exports = React.createClass({
  displayName: 'Dialog',
  propTypes:{
    theme: React.PropTypes.string,
    className: React.PropTypes.string,
    zIndexTop: React.PropTypes.bool,
    children: React.PropTypes.any,
    buttons: React.PropTypes.array,
    onClose: React.PropTypes.func,
    noPreventScrollClassNameList: React.PropTypes.array,
    needPreventScrollDefault: React.PropTypes.bool,
    closable: React.PropTypes.bool,
  },
  getDefaultProps() {
    return {
      theme: 'default',
      closable: true,
    };
  },
  componentDidMount() {
    const { noPreventScrollClassNameList, needPreventScrollDefault } = this.props;
    this.refs.modal.focus();

    if (!needPreventScrollDefault) {
      return;
    }
    this.preventScrollIntoScroll = preventScrollIntoScroll('.modal', noPreventScrollClassNameList);
    this.preventScrollIntoScroll.addMethod();
  },
  componentWillUnmount() {
    const { needPreventScrollDefault } = this.props;

    if (!needPreventScrollDefault) {
      return;
    }
    this.preventScrollIntoScroll.cancelMethod();
  },
  onClose(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }

    if (this.props.onClose) {
      this.props.onClose();
    }
  },
  render() {
    const { title, buttons, theme, className, closable, zIndexTop } = this.props;
    const buttonElems = (buttons || []).map((button, index) => {
      const btnCls = button.className || 'dialog-footer-btn-default';
      return (
        <button
          key={index}
          className={btnCls}
          onTouchTap={button.onClick}
        >
          {button.text}
        </button>
      );
    });

    const style = {
      // maxHeight: window.innerHeight - 44 - (buttonElems.length ? 49 : 0) - 40,
      maxHeight: 400,
    };
    return (
      <div className={`modal ${zIndexTop && 'modal-index-top'}`} ref="modal" tabIndex="-1">
        <div className="mask" onTouchTap={this.onClose}></div>
        <div className={`dialog ${theme} ${className || ''}`}>
          <div className="dialog-header">
            <p className="dialog-title">{title}</p>
            {closable && (<button className="btn dialog-btn-close" onTouchTap={this.onClose}></button>)}
          </div>
          <div className="dialog-body" style={style}>
            {this.props.children}
          </div>
          <div className="dialog-footer">
            {buttonElems}
          </div>
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/mui/dialog/dialog.jsx